import { FETCH_USER } from "../actions";

const DEFAULT_STATE = {
  user: {}
};

const userReducer = function (state = DEFAULT_STATE, action){
  switch (action.type) {
    case FETCH_USER:
      const data = action.payload;
      return data;
    default:
      return state;
  }
}

export default userReducer;